import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';

@Component({
  selector: 'app-action-dialog',
  templateUrl: './action-dialog.component.html',
  styleUrls: ['./action-dialog.component.css']
})
export class ActionDialogComponent implements OnInit {
  public buttonActions: any;
  public message: any;
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef) {
    this.buttonActions = config.data.buttonActions;
    this.message = config.data.message;
  }

  ngOnInit() {
  }

  public done() {
    this.ref.close();
  }

}
